import { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import { Button } from '../../../../../iba-components/Button'
import { showPopBanner } from '../../../../../iba-components/PopBanner'
import { Select } from '../../../../../iba-components/Select'
import { getALLClientList, updateEmrgncyStop } from '../../../../api/client_managementV2'
import ConfirmModal from '../../../../components/ConfirmModal'
import LoadingMask from '../../../../components/LoadingMask'
import './suspendAndTermination.css'
import styles from './suspendAndTermination.module.css'

class SuspendAndTerminationClass extends Component {
    constructor(props) {
        super(props)
        this.state = {
            options: [],
            selectedCompanyLabel: '',
            selectedCompany: '',
            visibleModal: false,
            visibleWarning: false,
            stopStatus: false
        }
    }

    onCompanySelected = (selectedCompany, content) => {
        if (selectedCompany) {
            this.setState({ selectedCompanyLabel: content })
            this.setState({ selectedCompany })

            if (selectedCompany !== this.props.id) {
                this.setState({ visibleWarning: true })
            } else {
                this.setState({ visibleWarning: false })
            }
        }
    }

    onModalSubmit = () => {
        const { t } = this.props
        let status = ''
        getALLClientList().then(({ clientList }) => {
            if (this.state.stopStatus) {
                status = '0'
            } else {
                status = '1'
            }
            updateEmrgncyStop({
                createby: this.props.userInfo.userinfo.username,
                clientid: this.state.selectedCompany.toString(),
                emrgncystop: status
            }).then((result) => {
                if (result.hasError === false) {
                    showPopBanner({
                        message: t(`signUpClient.warningMsg.registrationSuccess`),
                        status: 'success',
                        duration: 2000
                    })
                    getALLClientList().then(({ clientList }) => {
                        const selectClientList = clientList?.map((client) => {
                            return {
                                value: client.id,
                                content: `${client.companyname} - ${client.industries}`
                            }
                        })
                        this.setState({ options: selectClientList })
                        const stopStatus = clientList.find((element) => element.id === this.props.id).emrgncystop === 1
                        this.setState({ stopStatus })
                    })
                }
            })
            this.setState({ visibleModal: false })
        })
    }

    onButtonClick = () => {
        if (!this.state.visibleWarning && this.state.selectedCompany !== '') {
            this.setState({ visibleModal: true })
        }
    }

    componentDidMount() {
        getALLClientList().then(({ clientList }) => {
            const selectClientList = clientList?.map((client) => {
                return {
                    value: client.id,
                    content: `${client.companyname} - ${client.industries}`
                }
            })
            this.setState({ options: selectClientList })
            const stopStatus = clientList.find((element) => element.id === this.props.id)?.emrgncystop === 1
            this.setState({ stopStatus })
        })
    }

    render() {
        const { t } = this.props
        return (
            <div className="suspend-and-termination-container">
                {this.props.suspendAndTerminationLoading && <LoadingMask />}
                <div className={styles.form}>
                    <Select
                        itemKey="value"
                        width={470}
                        inputProps={{ value: this.state.selectedCompanyLabel }}
                        dataList={this.state.options}
                        handleChangeSelect={this.onCompanySelected}
                        selectedValue={this.state.selectedCompany}
                    />
                    <Button
                        label={
                            this.state.stopStatus
                                ? t('clientManagement.suspendAndTermination.emergencySuspendTrue')
                                : t('clientManagement.suspendAndTermination.emergencySuspendFalse')
                        }
                        onClick={this.onButtonClick}
                    />
                </div>
                {this.state.visibleWarning && (
                    <h6 className="warning">{t('clientManagement.suspendAndTermination.invalidCompanyWarning')}</h6>
                )}
                {this.state.visibleModal && (
                    <ConfirmModal
                        title={t('clientManagement.suspendAndTermination.emergencySuspendFalse')}
                        visible={this.state.visibleModal}
                        content={
                            this.state.stopStatus
                                ? t('clientManagement.suspendAndTermination.modalInfoTrue')
                                : t('clientManagement.suspendAndTermination.modalInfoFalse')
                        }
                        confirmBtnText={
                            this.state.stopStatus
                                ? t('clientManagement.suspendAndTermination.modalConfirmTrue')
                                : t('clientManagement.suspendAndTermination.modalConfirmFalse')
                        }
                        cancelBtnText={t('clientManagement.suspendAndTermination.modalCancel')}
                        onCancel={() => {
                            this.setState({ visibleModal: false })
                        }}
                        onSubmit={this.onModalSubmit}
                    />
                )}
            </div>
        )
    }
}

export const SuspendAndTermination = connect((state) => ({
    userInfo: state.userInfo
}))(withRouter(withTranslation()(SuspendAndTerminationClass)))
